import { isRecord } from 'fmrs';
const FIRST = 0;
const SINGLE = 1;
export default function isDefaultExport(value) {
    if (!isRecord(value)) {
        return false;
    }
    const keys = Object.keys(value);
    return keys.length === SINGLE && keys[FIRST] === 'default';
}
//# sourceMappingURL=is-default-export.js.map